document.addEventListener("DOMContentLoaded", function () {

  if (PUB_SUB_EVENTS) {
    subscribe(PUB_SUB_EVENTS.optionValueSelectionChange, (eventData) => {
      filterVariantDescription();
      //filterVariantMedia();
    });
  }

  function rhGetcurrentVariant(){
    const selectedVariant = document.querySelector('variant-selects [data-selected-variant]')?.innerHTML;
    return !!selectedVariant ? JSON.parse(selectedVariant) : null;   
  }

  function filterVariantDescription(){
    variant = rhGetcurrentVariant();
    if(!document.querySelector('.product-variant__description')) return;

    document.querySelectorAll('.product-variant__description').forEach((thumbnail) => {
      thumbnail.style.display = 'none';
    });

    if (document.querySelector('#variant-description-' + variant.id)){
      document.querySelector('#variant-description-' + variant.id).style.display = 'block';
    } else {
      document.querySelector('#variant-description-default').style.display = 'block';
    }
  }

  function filterVariantMedia(){
    const variant = rhGetcurrentVariant();
    const handle = variant.title.toLowerCase().replace(/ /g, '-').replace(/[^\w-]+/g, '');
    const medias = document.querySelectorAll(`[data-color="variant:${handle}"]`);

    if (medias){
      document.querySelectorAll('.product__media-item').forEach(media => media.style.display = 'none');
      
      medias.forEach((media) => {
        media.style.display = 'block';
      });
    }
  }

  const pairWithButton = document.querySelector('.pair-with__button ');
  if (pairWithButton) {
    pairWithButton.addEventListener('click', async (event) => {
      event.preventDefault();
      const variantId = pairWithButton.getAttribute('data-variant_id');

      let formData = new FormData();
      formData.append('id', variantId);
      formData.append('quantity', 1);
      formData.append('form_type', 'product');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];
      const cart = pairWithButton.closest('.relative-notification')?.querySelector('cart-notification') || document.querySelector('cart-notification') || document.querySelector('cart-drawer');

      formData.append(
        'sections',
        cart.getSectionsToRender().map((section) => section.id)
      );
      
      formData.append('sections_url', window.location.pathname);
      
      config.body = formData;

      pairWithButton.classList.add('loading');
      pairWithButton.setAttribute('disabled', 'disabled');

      await fetch(window.Shopify.routes.root + 'cart/add.js', config)
       .then((response) => response.json())
       .then((response) => {
          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'product-form',
            productVariantId: variantId,
            cartData: response,
          });

          cart.renderContents(response);

          return response;
       })
       .catch((error) => {
         console.error('Error:', error);
       })
       .finally(() => {
         pairWithButton.classList.remove('loading');
          pairWithButton.removeAttribute('disabled');
       });
    });
  }
});